SupportVerticalINTLStepThreeView = require('../views/step_three/INTL/vertical_view')
SupportOrdersCollection = require('../collections/orders')
SupportOrderModel = require('../models/order')
SupportCategorizationView = require('../views/categorization_view')
SupportVerticalStepOneView = require('../views/step_one/vertical_view')
SupportV2StepActionsModel = require('../models/v2_step_action')
StepTwoV2CMSView = require('../views/step_two/CMS/v2_cms_view')
SupportCMSModel = require('../models/CMS')
SupportFlexibleContactChannelModel = require('../models/flexible_contact_channels')
SupportLiveChatModel = require('../models/live_chat')
SupportLiveChatView = require('../views/live_chat_view')
SupportOptimizedContactChannelsModel = require('../models/optimized_contact_channels')
FAQHomeModel = require('../../../faq/frontend/models/home')
FAQTrendingArticlesView = require('../../../faq/frontend/views/trendingArticles')
SupportEmailSuccessView = require('../views/email_success_view')
SupportChatSuccessView = require('../views/chat_success_view')
SupportProblemSolvedView = require('../views/problem_solved_view')
SupportUserSignInView = require('../views/user_sign_in_view')
SupportEmailFormIntlFlexibleContactChannelsView = require('../views/email_form/INTL/flexible_contact_channels')
EmailFormOptimizedContactChannelView = require('../views/email_form/common/optimized_contact_channel_view')

class SupportVerticalHelpWizardViewManager
  constructor:  ->
    @configureContentModel()
    @configureFlexibleContentChannelsModel()
    @configureOptimizedContactChannelsModel()
    @configurePreEmailView()
    @homeModel = new FAQHomeModel()
    @initLiveChat()
    Groupon.Support.OrdersCollection = new SupportOrdersCollection()
    Groupon.Support.currentOrdersFilter = Groupon.Support.OrdersCollection.createPurchaseDateDescendingFilter()
    Groupon.Support.OrderModel = new SupportOrderModel()
    Groupon.Support.stepActionModel = new SupportV2StepActionsModel({
      showVerticalView: true
    })
    @stackedViews = []

  show: (view, params) ->
    {container} = params
    isNewViewAddedToStack = @setCurrentView(view, container)
    if isNewViewAddedToStack
      @moveActiveContainerToInactiveState()
      @activateContainer(container)
      Groupon.Support.CURRENTVIEW.render(params)
      $('.step-container', container).html(Groupon.Support.CURRENTVIEW.el)
    else
      @moveActiveContainerToDefaultState()
      @activateContainer(container)

    toggleCallUs(Groupon.Support.CURRENTVIEW.id)

  scrollTo: ($container) ->
    if $container
      hash =
        scrollTop: $container.offset()?.top
      $('html, body').animate(hash, 1000)
      #$(window).scrollTop($container.offset().top)

  renderTrendingArticles: ->
    @homeModel.fetch
      success: ( model, response, options ) =>
        stopTimer("t_fh")
        trendingArticlesView = new FAQTrendingArticlesView(model: @homeModel)
        trendingArticlesView.render()
      error: ( model, xhr, options )  =>
        @hideTrendingArticles()
        stopTimer("t_fh")

  hideTrendingArticles: ->
    $('.trending-articles-container').hide()

  setCurrentView: (currentView, container) ->
    if @removeStackedViewsAndUpdateCurrentView(currentView)
      return false
    peekedTopView = @peekStackedViews()
    if (peekedTopView?.view?.id? && currentView?.id? && peekedTopView.view.id is currentView.id)
      @removeView()
    Groupon.Support.CURRENTVIEW = currentView
    @addView(currentView, container)
    return true

  removeStackedViewsAndUpdateCurrentView: (currentView) ->
    isCurrentViewUpdated = false
    isRemoved = false
    while true
      peekedTopView = @peekStackedViews()
      if peekedTopView?.view.id? && currentView?.id? && peekedTopView.view.id > currentView.id
        isRemoved = true
        @moveContainerToDefaultState(peekedTopView.container)
        @removeView()
      else if isRemoved && peekedTopView
        @activateContainer(peekedTopView.container)
        Groupon.Support.CURRENTVIEW = peekedTopView.view
        isCurrentViewUpdated = true
        break
      else
        break
    return isCurrentViewUpdated

  addView: (currentView, container) ->
    @stackedViews.push({view: currentView, container})

  removeAllStackedViews: ->
    while true
      @removeView()
      peekedTopView = @peekStackedViews()
      break unless peekedTopView
    @moveAllContainerstoDefaultState()
    Groupon.Support.CURRENTVIEW = null

  removeView: ->
    popedTopView = @stackedViews.pop()
    if popedTopView?.view?
      popedTopView.view.remove()

  peekStackedViews: ->
    if @stackedViews.length > 0
      stackedView = @stackedViews[@stackedViews.length-1]
    else
      null

  moveActiveContainerToDefaultState: () ->
    $('.web-v2-circle.active').removeClass('active').removeClass('in-active')
    $('.web-v2-circle-text.active').removeClass('active').removeClass('in-active')
    $('.web-v2-help-text.active').removeClass('active').removeClass('in-active')

  moveActiveContainerToInactiveState: () ->
    $('.web-v2-circle.active').removeClass('active').addClass('in-active')
    $('.web-v2-circle-text.active').removeClass('active').addClass('in-active')
    $('.web-v2-help-text.active').removeClass('active').addClass('in-active')

  inActivateContainer: (container) ->
    $('.web-v2-circle', container).removeClass('active').addClass('in-active')
    $('.web-v2-circle-text', container).removeClass('active').addClass('in-active')
    $('.web-v2-help-text', container).removeClass('active').addClass('in-active')

  moveContainerToDefaultState: (container) ->
    $('.web-v2-circle', container).removeClass('active').removeClass('in-active')
    $('.web-v2-circle-text', container).removeClass('active').removeClass('in-active')
    $('.web-v2-help-text', container).removeClass('active').removeClass('in-active')

  activateContainer: (container) ->
    $('.web-v2-circle', container).removeClass('in-active').addClass('active')
    $('.web-v2-circle-text', container).removeClass('in-active').addClass('active')
    $('.web-v2-help-text', container).removeClass('in-active').addClass('active')

  moveAllContainerstoDefaultState: () ->
    _.each($('.web-v2-circle'), (ele)->
      $(ele).removeClass('active').removeClass('in-active')
    )
    _.each($('.web-v2-circle-text'), (ele)->
      $(ele).removeClass('active').removeClass('in-active')
    )
    _.each($('.web-v2-help-text'), (ele)->
      $(ele).removeClass('active').removeClass('in-active')
    )

  checkIfVerticalContainerIsVisible: () ->
    $('.vertical-container').is(":visible")

  resetVerticalContainer: ->
    @removeAllStackedViews()
    @categorizationView.resetGlobalValues()
    @categorizationView.deActivateCurrentActiveButton()
    @activateContainer($('#v2_step1'))
    $('.vertical-container').hide()

  render: () ->
    $container = $('#v2_step1')
    @renderTrendingArticles()
    @categorizationView = new SupportCategorizationView(el: $('.category-buttons', $container))
    @categorizationView.render()
    @scrollTo($('.page_header'))

  renderIntermediateView: ->

  renderOrders: ->
    @renderUserSignIn({myOrder: true, id: "my-order-sign-in"}) unless currentUser
    @removeAllStackedViews()
    $container = $('#v2_step1')
    stepOneView = @getStepOneView()
    @show(stepOneView, {container: $container})
    @scrollTo($container)
    stepOneView

  renderOrderDetails: (order) ->
    $container = $('#v2_step1')
    stepOneView = @getStepOneView()
    @show(stepOneView, {container: $container, order: order})
    @scrollTo($container)
    stepOneView

  renderDropDowns: ->
    if @checkIfVerticalContainerIsVisible()
      unless Groupon.Support.currentOrder
        @removeAllStackedViews()
        @activateContainer($('#v2_step1'))
      $container = $('#v2_step2')
      stepTwoView = @getStepTwoView()
      @show(stepTwoView, {container: $container})
      @scrollTo($container)
      stepTwoView
    else
      redirectToHelpWizard()

  renderUserSignIn: (options)->
    @removeAllStackedViews()
    $container = $('#v2_step1')
    userSignInView = @getUserSignView(options)
    @show(userSignInView, {container : $container})
    @scrollTo($container)
    userSignInView

  getUserSignView: (options)->
    new SupportUserSignInView(options)

  renderContactChannels: ->
    if @checkIfVerticalContainerIsVisible()
      $container = $('#v2_step3')
      stepThreeView = @getStepThreeView()
      @show(stepThreeView, {container: $container})
      stepThreeView.postRenderhandler()
      @scrollTo($container)
      stepThreeView
    else
      redirectToHelpWizard()

  ticketSuccess: ->
    @resetVerticalContainer()
    $container = $('#v2_other')
    ticketSuccessView  = new SupportEmailSuccessView
    @show(ticketSuccessView, {container: $container})
    @scrollTo($container)
    ticketSuccessView

  chatSuccess: ->
    @resetVerticalContainer()
    $container = $('#v2_other')
    chatSuccessView  = new SupportChatSuccessView
    @show(chatSuccessView, {container: $container})
    @scrollTo($container)
    chatSuccessView

  renderProblemSolved: ->
    $('.vertical-container').hide()
    $container = $('#v2_other')
    problemSolvedView = new SupportProblemSolvedView(isV2: true)
    @show(problemSolvedView, {container: $container})
    @scrollTo($container)
    problemSolvedView

  getStepOneView: ->
    new SupportVerticalStepOneView()

  getStepTwoView: ->
    Groupon.Support.StepTwoView = new StepTwoV2CMSView({
       dropDownModel: Groupon.Support.ContentModel.dropDowns
    })

  getStepThreeView: ->
    new SupportVerticalINTLStepThreeView()

  configureContentModel: ->
    Groupon.Support.ContentModel = new SupportCMSModel

  configureFlexibleContentChannelsModel: ->
    Groupon.Support.FlexibleContactChannelModel = new SupportFlexibleContactChannelModel

  configureOptimizedContactChannelsModel: ->
    Groupon.Support.OptimizedContactChannelsModel = new SupportOptimizedContactChannelsModel

  configurePreEmailView: ->
    if window.evaluate(window.experiments.showFlexibleContactChannels)
      Groupon.Support.PreEmailView = SupportEmailFormIntlFlexibleContactChannelsView
    else
      Groupon.Support.PreEmailView = EmailFormOptimizedContactChannelView

  initLiveChat: ->
    Groupon.Support.LiveChatModel = new SupportLiveChatModel()
    Groupon.Support.LiveChatView = new SupportLiveChatView {model: Groupon.Support.LiveChatModel}

module.exports = SupportVerticalHelpWizardViewManager
